const DetailsEventsWrapper = (modifiedModel: any) => (promises: Promise<any>[]) => {
	return Promise.all(promises).then(results => {
		return Object.assign(modifiedModel, ...results);
	});
};

export default DetailsEventsWrapper;
